export const companyColumnTranslationKeysByColumn = new Map([
    ['business_number', 'gin_steps|company_business_number'],
    ['cra_number', 'gin_steps|craNumber'],
    ['naics_code', 'gin_steps|company_naics_code'],
    ['city', 'gin_steps|company_city'],
    ['size', 'gin_steps|company_size'],
    ['province', 'gin_steps|company_province'],
    ['founded_at', 'gin_steps|company_founded_at'],
    ['industry_sector', 'gin_steps|company_industry_sector'],
    ['industry_subsector', 'gin_steps|company_industry_subsector'],
    ['exact_annual_revenue', 'gin_steps|company_annual_revenue'],
]);
export const programColumnTranslationKeysByColumn = new Map([
    ['program_requested_at', 'gin_steps|program_requested_at'],
    ['program_targeted_amount', 'gin_steps|program_targeted_amount'],
]);
